export default function useActionPlayer (booking, bookingStationTimes, editBooking) {
  function setNumberOfPlayers (number) {
    editBooking('numPlayers', number);
  }

  function handlePlayers () {
    if (booking.value.numPlayers < bookingStationTimes.value.length) {
      setNumberOfPlayers(bookingStationTimes.value.length);
    }
  }

  return {
    handlePlayers,
  };
}
